import { render, staticRenderFns } from "./sourceCard.vue?vue&type=template&id=11dece63&"
import script from "./sourceCard.vue?vue&type=script&lang=js&"
export * from "./sourceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports